var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25H12C12.1989 1.25 12.3897 1.32902 12.5303 1.46967L21.1219 10.0612C21.6341 10.5765 21.9216 11.2735 21.9216 12C21.9216 12.7265 21.6341 13.4235 21.1219 13.9388L21.1203 13.9403L13.9506 21.11C13.6952 21.3657 13.3919 21.5686 13.0581 21.7069C12.7242 21.8453 12.3664 21.9166 12.005 21.9166C11.6436 21.9166 11.2858 21.8453 10.9519 21.7069C10.6182 21.5686 10.315 21.3659 10.0597 21.1104C10.0596 21.1103 10.0598 21.1105 10.0597 21.1104L1.46998 12.5306C1.32914 12.39 1.25 12.1991 1.25 12V2ZM2.75 2.75V11.6891L11.12 20.0494C11.2361 20.1656 11.3746 20.2584 11.5263 20.3213C11.6781 20.3842 11.8407 20.4166 12.005 20.4166C12.1693 20.4166 12.3319 20.3842 12.4837 20.3213C12.6354 20.2584 12.7733 20.1662 12.8894 20.05L20.0581 12.8812C20.0579 12.8814 20.0583 12.8811 20.0581 12.8812C20.2905 12.6471 20.4216 12.33 20.4216 12C20.4216 11.67 20.2911 11.3535 20.0587 11.1193C20.0585 11.1191 20.0589 11.1195 20.0587 11.1193L11.6893 2.75H2.75Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 7C6.25 6.58579 6.58579 6.25 7 6.25H7.01C7.42421 6.25 7.76 6.58579 7.76 7C7.76 7.41421 7.42421 7.75 7.01 7.75H7C6.58579 7.75 6.25 7.41421 6.25 7Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.5cb89a0313d07c0e3b523f9f4bce2d72.svg";
export { ForwardRef as ReactComponent };